import moment from 'moment';
import { TIMESTAMP_REGEX } from '../../constants/settings';

const LogInfo = ({
  title,
  prevValue,
  currentValue,
}: {
  title: string;
  prevValue: any;
  currentValue: any;
}) => {
  // rendering log info component here
  return (
    <div>
      <p className='italic'>
        <span
          className={`capitalize ${
            typeof currentValue === 'boolean'
              ? 'text-legal-dark-blue'
              : currentValue
              ? 'text-legal-dark-blue'
              : 'text-gray-400'
          }`}
        >
          {title}:{' '}
        </span>{' '}
        {title !== 'password' ? (
          <span
            className={`font-semibold ${
              typeof currentValue === 'boolean'
                ? 'text-base-red line-through'
                : currentValue
                ? 'text-base-red line-through'
                : 'text-gray-400'
            }`}
          >
            {typeof prevValue === 'boolean'
              ? prevValue === true
                ? 'Yes'
                : 'No'
              : TIMESTAMP_REGEX.test(prevValue)
              ? moment(prevValue).format('DD-MM-YYYY hh:mm A')
              : prevValue
              ? prevValue
              : 'N/A'}
          </span>
        ) : null}{' '}
        <span className='font-semibold text-base-cyan'>
          {' '}
          {typeof currentValue === 'boolean'
            ? currentValue === true
              ? 'Yes'
              : 'No'
            : TIMESTAMP_REGEX.test(currentValue)
            ? moment(currentValue).format('DD-MM-YYYY hh:mm A')
            : currentValue}
        </span>
      </p>
    </div>
  );
};

export default LogInfo;
